const link = {
  MuiLink: {
    defaultProps: {
      underline: 'hover',
      color: 'primary.dark',
    },
  },
};

export default link;
